import moneyMagnet from "../assets/product/Bracelets/money-magnet.png";
import roseQuartz from "../assets/product/Bracelets/rose-quartz.png";
import greenAventurine from "../assets/product/Bracelets/Green-Aventurine.png";
import amethyst from "../assets/product/Bracelets/Amethyst-Bracelet.png";
import sulemani from "../assets/product/Bracelets/Sulemani-Hakik.png";
import clearQuartz from "../assets/product/Bracelets/Clear-Quartz.png";
import blackTourmaline from "../assets/product/Bracelets/Black-Tourmaline.png";
import yellowTigerEye from "../assets/product/Bracelets/Yellow-TigerEye.png";


import rud1 from "../assets/product/Rudraksha/1mukhi.jpg";
import rud2 from "../assets/product/Rudraksha/2mukhi.jpg";
import rud3 from "../assets/product/Rudraksha/3mukhi.webp";
import rud4 from "../assets/product/Rudraksha/4mukhi.webp";
import rud5 from "../assets/product/Rudraksha/5mukhi.webp";
import rud6 from "../assets/product/Rudraksha/6mukhi.webp";
import rud7 from "../assets/product/Rudraksha/7mukhi.webp";
import rud8 from "../assets/product/Rudraksha/8mukhi.jpeg";
import rud9 from "../assets/product/Rudraksha/9mukhi.webp";
import rud10 from "../assets/product/Rudraksha/10mukhi.jfif";
import rud11 from "../assets/product/Rudraksha/11mukhi.webp";
import rud12 from "../assets/product/Rudraksha/12mukhi.webp";
import rud13 from "../assets/product/Rudraksha/13mukhi.jfif";
import rud14 from "../assets/product/Rudraksha/14mukhi.jpg";



import rudrakshaMala from "../assets/product/Mala/rudraksha-mala.png";
import tulsiMala from "../assets/product/Mala/tulsi-mala.png";
import sandalwoodMala from "../assets/product/Mala/sandalwood-mala.png";
import crystalMala from "../assets/product/Mala/crystal-mala.png";
import lotusSeedMala from "../assets/product/Mala/lotusseed-mala.png";
import bodhiSeedMala from "../assets/product/Mala/bodhi-seed-mala.png";
import paradMala from "../assets/product/Mala/parad-mala.png";


// --- Gemstone Images (placeholder imports) ---
import rubyImg from "../assets/product/Gemstone/ruby.png";
import pearlImg from "../assets/product/Gemstone/pearl.png";
import redCoralImg from "../assets/product/Gemstone/red-coral.png";
import emeraldImg from "../assets/product/Gemstone/emerald.png";
import yellowSapphireImg from "../assets/product/Gemstone/yellow-sapphire.png";
import diamondImg from "../assets/product/Gemstone/diamond.png";
import blueSapphireImg from "../assets/product/Gemstone/blue-sapphire.png";
import hessoniteImg from "../assets/product/Gemstone/hessonite.png";
import catsEyeImg from "../assets/product/Gemstone/cats-eye.png";
import amethystImg from "../assets/product/Gemstone/amethyst.png";
import citrineImg from "../assets/product/Gemstone/citrine.png";
import garnetImg from "../assets/product/Gemstone/garnet.png";
import peridotImg from "../assets/product/Gemstone/peridot.png";
import turquoiseImg from "../assets/product/Gemstone/turquoise.png";
import aquamarineImg from "../assets/product/Gemstone/aquamarine.png";
import topazImg from "../assets/product/Gemstone/topaz.png";
import moonstoneImg from "../assets/product/Gemstone/moonstone.png";
import lapisLazuliImg from "../assets/product/Gemstone/lapis-lazuli.png";
import onyxImg from "../assets/product/Gemstone/onyx.png";
import sunstoneImg from "../assets/product/Gemstone/sunstone.png";
import bloodstoneImg from "../assets/product/Gemstone/bloodstone.png";
import malachiteImg from "../assets/product/Gemstone/malachite.png";



import sevenChakraRing from "../assets/product/Healing-Accessories/seven-chakra-ring.jpeg"; // import your image


const products = [
  {
    id: "money-magnet",
    name: "Natural Money Magnet Stone Bracelet",
    img: moneyMagnet,
    price: 699,
    oldPrice: 1999,
    offer: "45% + Extra 20% OFF",
    desc: "Attracts wealth, prosperity, and abundance into your life.",
    description:
      "The Money Magnet Bracelet is designed with natural stones that attract prosperity, abundance, and financial stability.",
    crystals: ["Pyrite", "Citrine", "Green Aventurine"],
    benefits: [
      "Attracts wealth and prosperity",
      "Boosts confidence in financial decisions",
      "Improves opportunities for growth",
    ],
    howToWear: "Wear on your left hand for maximum attraction of wealth energy.",
    bestDay: "Friday and Thursday are considered most auspicious.",
    category: "bracelet", // ✅ added
  },
  {
    id: "rose-quartz",
    name: "Natural Rose Quartz Bracelet",
    img: roseQuartz,
    price: 599,
    oldPrice: 1299,
    offer: "40% OFF",
    desc: "Stone of love, harmony, and emotional healing.",
    description:
      "Rose Quartz, known as the stone of love, brings harmony in relationships and promotes emotional healing.",
    crystals: ["Rose Quartz"],
    benefits: [
      "Promotes unconditional love",
      "Heals emotional wounds",
      "Restores harmony in relationships",
    ],
    howToWear: "Wear on the left wrist for attracting love and harmony.",
    bestDay: "Friday is the best day to wear Rose Quartz.",
    category: "bracelet",
  },
  {
    id: "green-aventurine",
    name: "Green Aventurine Bracelet",
    img: greenAventurine,
    price: 649,
    oldPrice: 1499,
    offer: "50% OFF",
    desc: "Known as the stone of luck and opportunity.",
    description:
      "Green Aventurine is considered the stone of luck, helping to manifest opportunities and attract good fortune.",
    crystals: ["Green Aventurine"],
    benefits: [
      "Brings good luck and prosperity",
      "Enhances creativity and motivation",
      "Helps in making clear decisions",
    ],
    howToWear: "Wear on the left wrist to attract luck and positive opportunities.",
    bestDay: "Wednesday is the most auspicious day.",
    category: "bracelet",
  },
  {
    id: "amethyst",
    name: "Natural Amethyst Bracelet",
    img: amethyst,
    price: 749,
    oldPrice: 1499,
    offer: "50% OFF",
    desc: "Promotes peace, calm, and spiritual awareness.",
    description:
      "Amethyst is a calming stone that promotes peace, balances emotions, and enhances spiritual awareness.",
    crystals: ["Amethyst"],
    benefits: [
      "Reduces stress and anxiety",
      "Improves focus during meditation",
      "Promotes restful sleep",
    ],
    howToWear: "Wear on the right hand to enhance calmness and focus.",
    bestDay: "Monday and Saturday are ideal.",
    category: "bracelet",
  },
  {
    id: "sulemani-hakik",
    name: "Natural Sulemani Hakik Bracelet",
    img: sulemani,
    price: 599,
    oldPrice: 1299,
    offer: "40% OFF",
    desc: "Protects from negativity and balances energy.",
    description:
      "Sulemani Hakik is a powerful stone that protects from negativity, evil eye, and helps balance inner energy.",
    crystals: ["Sulemani Hakik"],
    benefits: [
      "Shields from negative energies",
      "Balances emotional and physical health",
      "Strengthens intuition",
    ],
    howToWear: "Wear on the left hand to absorb protective energies.",
    bestDay: "Saturday is the most suitable day.",
    category: "bracelet",
  },
  {
    id: "clear-quartz",
    name: "Natural Clear Quartz (Spatic) Bracelet",
    img: clearQuartz,
    price: 699,
    oldPrice: 1499,
    offer: "50% OFF",
    desc: "Powerful healing stone, enhances clarity and focus.",
    description:
      "Clear Quartz is known as the 'master healer'. It amplifies energy, enhances clarity, and supports overall healing.",
    crystals: ["Clear Quartz"],
    benefits: [
      "Enhances concentration and focus",
      "Amplifies positive energies",
      "Boosts immunity and healing",
    ],
    howToWear: "Wear daily for mental clarity and healing benefits.",
    bestDay: "Sunday and full moon days.",
    category: "bracelet",
  },
  {
    id: "black-tourmaline",
    name: "Natural Black Tourmaline Bracelet",
    img: blackTourmaline,
    price: 799,
    oldPrice: 1599,
    offer: "50% OFF",
    desc: "Strong protection stone against negative energies.",
    description:
      "Black Tourmaline is a powerful grounding stone that provides protection from negative energies and psychic attacks.",
    crystals: ["Black Tourmaline"],
    benefits: [
      "Shields from negative energies",
      "Reduces stress and anxiety",
      "Improves confidence and stability",
    ],
    howToWear: "Wear on the left hand for protection and grounding.",
    bestDay: "Saturday is ideal.",
    category: "bracelet",
  },
  {
    id: "yellow-tiger-eye",
    name: "Natural Yellow Tiger Eye Bracelet",
    img: yellowTigerEye,
    price: 699,
    oldPrice: 1499,
    offer: "50% OFF",
    desc: "Boosts confidence, courage, and decision making.",
    description:
      "Tiger Eye is a stone of courage and motivation. It boosts confidence and sharpens decision-making skills.",
    crystals: ["Tiger Eye"],
    benefits: [
      "Enhances courage and confidence",
      "Helps in overcoming fear",
      "Sharpens focus and decision making",
    ],
    howToWear: "Wear on the right hand for courage and confidence.",
    bestDay: "Tuesday and Sunday are auspicious.",
    category: "bracelet",
  },

  {
    id: "1-mukhi",
    name: "1 Mukhi Rudraksha",
    img: rud1,
    price: 1499,
    oldPrice: 2999,
    offer: "50% OFF",
    desc: "Represents Lord Shiva, brings spiritual growth.",
    description:
      "1 Mukhi Rudraksha is considered very rare and powerful. It helps in spiritual awakening and connecting with divine energy.",
    benefits: ["Spiritual growth", "Meditation aid", "Mental clarity"],
    howToWear: "Wear on the right hand with silver chain.",
    bestDay: "Monday",
    category: "rudraksha",
  },
  {
    id: "2-mukhi",
    name: "2 Mukhi Rudraksha",
    img: rud2,
    price: 1299,
    oldPrice: 2599,
    offer: "50% OFF",
    desc: "Represents Ardhanarishwar, enhances relationships.",
    description:
      "2 Mukhi Rudraksha strengthens bonds between couples, promotes harmony, and supports emotional balance.",
    benefits: ["Relationship harmony", "Emotional stability", "Love & compassion"],
    howToWear: "Wear on the right hand with silver chain.",
    bestDay: "Monday",
    category: "rudraksha",
  },
  {
    id: "3-mukhi",
    name: "3 Mukhi Rudraksha",
    img: rud3,
    price: 1199,
    oldPrice: 2399,
    offer: "50% OFF",
    desc: "Represents Agni, removes past karmas.",
    description:
      "3 Mukhi Rudraksha helps in spiritual purification, clears past karmic debts, and improves energy levels.",
    benefits: ["Karma clearance", "Energy boost", "Spiritual protection"],
    howToWear: "Wear on right hand or throat chakra.",
    bestDay: "Tuesday",
    category: "rudraksha",
  },
  {
    id: "4-mukhi",
    name: "4 Mukhi Rudraksha",
    img: rud4,
    price: 1099,
    oldPrice: 2199,
    offer: "50% OFF",
    desc: "Represents Lord Brahma, enhances intellect.",
    description:
      "4 Mukhi Rudraksha enhances wisdom, learning ability, and mental clarity.",
    benefits: ["Intellect enhancement", "Memory boost", "Decision making"],
    howToWear: "Wear on the right hand index finger.",
    bestDay: "Thursday",
    category: "rudraksha",
  },
  {
    id: "5-mukhi",
    name: "5 Mukhi Rudraksha",
    img: rud5,
    price: 999,
    oldPrice: 1999,
    offer: "50% OFF",
    desc: "Represents Lord Shiva, provides overall well-being.",
    description:
      "5 Mukhi Rudraksha is most common and known for health, peace, and general well-being.",
    benefits: ["Health", "Peace", "Spiritual growth"],
    howToWear: "Wear on right hand.",
    bestDay: "Monday",
    category: "rudraksha",
  },
  {
    id: "6-mukhi",
    name: "6 Mukhi Rudraksha",
    img: rud6,
    price: 899,
    oldPrice: 1799,
    offer: "50% OFF",
    desc: "Represents Lord Kartikeya, improves communication.",
    description:
      "6 Mukhi Rudraksha is associated with Lord Kartikeya and helps in improving communication skills and confidence.",
    benefits: ["Communication", "Confidence", "Leadership"],
    howToWear: "Wear on right hand.",
    bestDay: "Wednesday",
    category: "rudraksha",
  },
  {
    id: "7-mukhi",
    name: "7 Mukhi Rudraksha",
    img: rud7,
    price: 849,
    oldPrice: 1699,
    offer: "50% OFF",
    desc: "Represents Goddess Mahalakshmi, brings wealth.",
    description:
      "7 Mukhi Rudraksha is known for prosperity, wealth, and abundance.",
    benefits: ["Wealth", "Prosperity", "Financial stability"],
    howToWear: "Wear on right hand.",
    bestDay: "Thursday",
    category: "rudraksha",
  },
  {
    id: "8-mukhi",
    name: "8 Mukhi Rudraksha",
    img: rud8,
    price: 799,
    oldPrice: 1599,
    offer: "50% OFF",
    desc: "Represents Lord Ganesha, removes obstacles.",
    description:
      "8 Mukhi Rudraksha helps remove obstacles in life, improves career, and provides mental strength.",
    benefits: ["Obstacle removal", "Career growth", "Mental strength"],
    howToWear: "Wear on right hand.",
    bestDay: "Wednesday",
    category: "rudraksha",
  },
  {
    id: "9-mukhi",
    name: "9 Mukhi Rudraksha",
    img: rud9,
    price: 749,
    oldPrice: 1499,
    offer: "50% OFF",
    desc: "Represents Goddess Durga, provides courage.",
    description:
      "9 Mukhi Rudraksha gives courage, self-confidence, and helps overcome fear.",
    benefits: ["Courage", "Confidence", "Protection"],
    howToWear: "Wear on right hand.",
    bestDay: "Tuesday",
    category: "rudraksha",
  },
  {
    id: "10-mukhi",
    name: "10 Mukhi Rudraksha",
    img: rud10,
    price: 699,
    oldPrice: 1399,
    offer: "50% OFF",
    desc: "Represents Lord Vishnu, brings success.",
    description:
      "10 Mukhi Rudraksha helps in achieving success in business, career, and personal life.",
    benefits: ["Success", "Wealth", "Spiritual growth"],
    howToWear: "Wear on right hand.",
    bestDay: "Thursday",
    category: "rudraksha",
  },
  {
    id: "11-mukhi",
    name: "11 Mukhi Rudraksha",
    img: rud11,
    price: 649,
    oldPrice: 1299,
    offer: "50% OFF",
    desc: "Represents Lord Hanuman, removes stress.",
    description:
      "11 Mukhi Rudraksha reduces stress, protects from negative energies, and improves focus.",
    benefits: ["Stress relief", "Focus", "Protection"],
    howToWear: "Wear on right hand.",
    bestDay: "Tuesday",
    category: "rudraksha",
  },
  {
    id: "12-mukhi",
    name: "12 Mukhi Rudraksha",
    img: rud12,
    price: 599,
    oldPrice: 1199,
    offer: "50% OFF",
    desc: "Represents Lord Sun, provides energy.",
    description:
      "12 Mukhi Rudraksha increases energy, vitality, and overall health.",
    benefits: ["Energy", "Vitality", "Health"],
    howToWear: "Wear on right hand.",
    bestDay: "Sunday",
    category: "rudraksha",
  },
  {
    id: "13-mukhi",
    name: "13 Mukhi Rudraksha",
    img: rud13,
    price: 549,
    oldPrice: 1099,
    offer: "50% OFF",
    desc: "Represents Lord Indra, grants divine blessings.",
    description:
      "13 Mukhi Rudraksha brings divine blessings, spiritual growth, and protection.",
    benefits: ["Divine blessings", "Protection", "Spiritual growth"],
    howToWear: "Wear on right hand.",
    bestDay: "Thursday",
    category: "rudraksha",
  },
  {
    id: "14-mukhi",
    name: "14 Mukhi Rudraksha",
    img: rud14,
    price: 499,
    oldPrice: 999,
    offer: "50% OFF",
    desc: "Represents Lord Hanuman, enhances courage and self-confidence.",
    description:
      "14 Mukhi Rudraksha is powerful for courage, leadership, and self-confidence.",
    benefits: ["Courage", "Leadership", "Confidence"],
    howToWear: "Wear on right hand.",
    bestDay: "Tuesday",
    category: "rudraksha",
  },
  {
    id: "rudraksha-mala",
    name: "Rudraksha Mala",
    img: rudrakshaMala,
    price: 1299,
    oldPrice: 2599,
    offer: "50% OFF",
    desc: "Spiritual Rudraksha beads for meditation and protection.",
    description:
      "Rudraksha Mala enhances meditation, spiritual growth, and provides protection from negative energies.",
    benefits: ["Meditation", "Protection", "Spiritual growth"],
    howToWear: "Wear around neck or use during meditation.",
    bestDay: "Monday",
    category: "mala",
  },
  {
    id: "tulsi-mala",
    name: "Tulsi Mala",
    img: tulsiMala,
    price: 999,
    oldPrice: 1999,
    offer: "50% OFF",
    desc: "Sacred Tulsi beads for devotion and healing.",
    description:
      "Tulsi Mala helps in spiritual healing, devotion, and promotes overall well-being.",
    benefits: ["Devotion", "Healing", "Peace of mind"],
    howToWear: "Wear around neck or wrist.",
    bestDay: "Thursday",
    category: "mala",
  },
  {
    id: "sandalwood-mala",
    name: "Sandalwood Mala",
    img: sandalwoodMala,
    price: 899,
    oldPrice: 1799,
    offer: "50% OFF",
    desc: "Fragrant sandalwood beads for meditation and calmness.",
    description:
      "Sandalwood Mala helps calm the mind, improves focus, and is ideal for meditation practices.",
    benefits: ["Calmness", "Focus", "Meditation"],
    howToWear: "Wear around neck or wrist.",
    bestDay: "Friday",
    category: "mala",
  },
  {
    id: "crystal-mala",
    name: "Crystal Mala",
    img: crystalMala,
    price: 1499,
    oldPrice: 2999,
    offer: "50% OFF",
    desc: "Healing crystal beads for energy and positivity.",
    description:
      "Crystal Mala boosts positive energy, enhances meditation, and provides spiritual clarity.",
    benefits: ["Healing", "Positive energy", "Meditation"],
    howToWear: "Wear around neck or use during meditation.",
    bestDay: "Sunday",
    category: "mala",
  },
  {
    id: "lotusseed-mala",
    name: "Lotus Seed Mala",
    img: lotusSeedMala,
    price: 799,
    oldPrice: 1599,
    offer: "50% OFF",
    desc: "Natural lotus seed beads for mindfulness and meditation.",
    description:
      "Lotus Seed Mala improves concentration, mindfulness, and spiritual connection.",
    benefits: ["Mindfulness", "Focus", "Meditation"],
    howToWear: "Wear around neck or wrist.",
    bestDay: "Wednesday",
    category: "mala",
  },
  {
    id: "bodhiseed-mala",
    name: "Bodhi Seed Mala",
    img: bodhiSeedMala,
    price: 899,
    oldPrice: 1799,
    offer: "50% OFF",
    desc: "Bodhi seed beads for enlightenment and meditation.",
    description:
      "Bodhi Seed Mala promotes spiritual awakening, meditation, and inner peace.",
    benefits: ["Enlightenment", "Meditation", "Inner peace"],
    howToWear: "Wear around neck or use during meditation.",
    bestDay: "Thursday",
    category: "mala",
  },
  {
    id: "parad-mala",
    name: "Parad Mala",
    img: paradMala,
    price: 1999,
    oldPrice: 3999,
    offer: "50% OFF",
    desc: "Holy Parad (mercury) beads for powerful spiritual benefits.",
    description:
      "Parad Mala is used for spiritual protection, increased energy, and divine blessings.",
    benefits: ["Protection", "Energy", "Spiritual blessings"],
    howToWear: "Wear around neck or wrist with care.",
    bestDay: "Saturday",
    category: "mala",
  }, {
    id: "ruby",
    name: "Ruby",
    img: rubyImg,
    price: 4999,
    oldPrice: 7999,
    offer: "40% OFF",
    desc: "Symbol of passion, energy, and success.",
    description: "Ruby is known to enhance vitality, courage, and leadership qualities.",
    benefits: ["Passion", "Energy", "Success"],
    howToWear: "Wear on the ring finger for maximum effect.",
    bestDay: "Sunday",
    category: "gemstone",
  },
  {
    id: "pearl",
    name: "Pearl",
    img: pearlImg,
    price: 1999,
    oldPrice: 3999,
    offer: "50% OFF",
    desc: "Symbol of purity, calmness, and emotional balance.",
    description: "Pearls are believed to bring peace, emotional balance, and mental clarity.",
    benefits: ["Purity", "Calmness", "Emotional balance"],
    howToWear: "Wear on the little finger of the right hand.",
    bestDay: "Monday",
    category: "gemstone",
  },
  {
    id: "red-coral",
    name: "Red Coral",
    img: redCoralImg,
    price: 2999,
    oldPrice: 5999,
    offer: "50% OFF",
    desc: "Increases energy, courage, and confidence.",
    description: "Red Coral enhances vitality, protects against negative energies, and improves decision-making.",
    benefits: ["Energy", "Courage", "Confidence"],
    howToWear: "Wear on the ring finger of the right hand.",
    bestDay: "Tuesday",
    category: "gemstone",
  },
  {
    id: "emerald",
    name: "Emerald",
    img: emeraldImg,
    price: 6999,
    oldPrice: 11999,
    offer: "40% OFF",
    desc: "Symbol of wisdom, prosperity, and mental clarity.",
    description: "Emerald improves communication skills, intellectual growth, and attracts prosperity.",
    benefits: ["Wisdom", "Prosperity", "Mental clarity"],
    howToWear: "Wear on the little finger of the right hand.",
    bestDay: "Wednesday",
    category: "gemstone",
  },
  {
    id: "yellow-sapphire",
    name: "Yellow Sapphire",
    img: yellowSapphireImg,
    price: 7999,
    oldPrice: 13999,
    offer: "45% OFF",
    desc: "Promotes wealth, learning, and spiritual growth.",
    description: "Yellow Sapphire enhances knowledge, financial prosperity, and spiritual wisdom.",
    benefits: ["Wealth", "Learning", "Spiritual growth"],
    howToWear: "Wear on the index finger of the right hand.",
    bestDay: "Thursday",
    category: "gemstone",
  },
  {
    id: "diamond",
    name: "Diamond",
    img: diamondImg,
    price: 14999,
    oldPrice: 24999,
    offer: "40% OFF",
    desc: "Enhances power, clarity, and confidence.",
    description: "Diamond strengthens willpower, courage, and mental clarity.",
    benefits: ["Power", "Clarity", "Confidence"],
    howToWear: "Wear on the ring finger of the right hand.",
    bestDay: "Friday",
    category: "gemstone",
  },
  {
    id: "blue-sapphire",
    name: "Blue Sapphire",
    img: blueSapphireImg,
    price: 12999,
    oldPrice: 22999,
    offer: "45% OFF",
    desc: "Brings discipline, protection, and prosperity.",
    description: "Blue Sapphire provides mental focus, protects from negativity, and attracts wealth.",
    benefits: ["Discipline", "Protection", "Prosperity"],
    howToWear: "Wear on the middle finger of the right hand.",
    bestDay: "Saturday",
    category: "gemstone",
  },
  {
    id: "hessonite",
    name: "Hessonite",
    img: hessoniteImg,
    price: 4999,
    oldPrice: 9999,
    offer: "50% OFF",
    desc: "Protects against negativity and enhances confidence.",
    description: "Hessonite improves self-confidence, reduces stress, and protects from evil eye.",
    benefits: ["Protection", "Confidence", "Stress relief"],
    howToWear: "Wear on the middle finger of the right hand.",
    bestDay: "Sunday",
    category: "gemstone",
  },
  {
    id: "cats-eye",
    name: "Cat's Eye",
    img: catsEyeImg,
    price: 6999,
    oldPrice: 12999,
    offer: "45% OFF",
    desc: "Enhances intuition and financial prosperity.",
    description: "Cat’s Eye protects from evil, enhances intuition, and brings financial growth.",
    benefits: ["Intuition", "Protection", "Prosperity"],
    howToWear: "Wear on the middle finger of the right hand.",
    bestDay: "Wednesday",
    category: "gemstone",
  },
  {
    id: "amethystGemstone",
    name: "Amethyst",
    img: amethystImg,
    price: 2999,
    oldPrice: 5999,
    offer: "50% OFF",
    desc: "Calms mind, enhances focus and spiritual growth.",
    description: "Amethyst reduces stress, improves meditation, and spiritual awareness.",
    benefits: ["Calmness", "Focus", "Spiritual growth"],
    howToWear: "Wear on the middle finger or wrist.",
    bestDay: "Monday",
    category: "gemstone",
  },
  {
    id: "citrine",
    name: "Citrine",
    img: citrineImg,
    price: 2999,
    oldPrice: 5999,
    offer: "50% OFF",
    desc: "Brings abundance, positivity, and success.",
    description: "Citrine attracts wealth, enhances confidence, and promotes positive energy.",
    benefits: ["Abundance", "Positivity", "Success"],
    howToWear: "Wear on the index finger of the right hand.",
    bestDay: "Thursday",
    category: "gemstone",
  },
  {
    id: "garnet",
    name: "Garnet",
    img: garnetImg,
    price: 1999,
    oldPrice: 3999,
    offer: "50% OFF",
    desc: "Boosts energy, passion, and health.",
    description: "Garnet revitalizes energy, improves health, and enhances passion.",
    benefits: ["Energy", "Passion", "Health"],
    howToWear: "Wear on the ring finger of the right hand.",
    bestDay: "Tuesday",
    category: "gemstone",
  },
  {
    id: "peridot",
    name: "Peridot",
    img: peridotImg,
    price: 2499,
    oldPrice: 4999,
    offer: "50% OFF",
    desc: "Promotes growth, abundance, and positivity.",
    description: "Peridot improves personal growth, prosperity, and brings positive vibes.",
    benefits: ["Growth", "Abundance", "Positivity"],
    howToWear: "Wear on the little finger of the right hand.",
    bestDay: "Thursday",
    category: "gemstone",
  },
  {
    id: "turquoise",
    name: "Turquoise",
    img: turquoiseImg,
    price: 2999,
    oldPrice: 5999,
    offer: "50% OFF",
    desc: "Healing stone for protection and communication.",
    description: "Turquoise enhances healing, improves communication, and protects against negative energies.",
    benefits: ["Healing", "Protection", "Communication"],
    howToWear: "Wear on the middle finger or necklace.",
    bestDay: "Wednesday",
    category: "gemstone",
  },
  {
    id: "aquamarine",
    name: "Aquamarine",
    img: aquamarineImg,
    price: 3499,
    oldPrice: 6999,
    offer: "50% OFF",
    desc: "Calms emotions and enhances courage.",
    description: "Aquamarine reduces stress, improves courage, and enhances clarity of thought.",
    benefits: ["Calmness", "Courage", "Clarity"],
    howToWear: "Wear on the index or middle finger.",
    bestDay: "Monday",
    category: "gemstone",
  },
  {
    id: "topaz",
    name: "Topaz",
    img: topazImg,
    price: 2999,
    oldPrice: 5999,
    offer: "50% OFF",
    desc: "Brings wealth, success, and clarity.",
    description: "Topaz enhances personal growth, attracts wealth, and improves focus.",
    benefits: ["Wealth", "Success", "Clarity"],
    howToWear: "Wear on the ring finger.",
    bestDay: "Thursday",
    category: "gemstone",
  },
  {
    id: "moonstone",
    name: "Moonstone",
    img: moonstoneImg,
    price: 1999,
    oldPrice: 3999,
    offer: "50% OFF",
    desc: "Balances emotions and enhances intuition.",
    description: "Moonstone improves emotional stability, intuition, and spiritual growth.",
    benefits: ["Emotional balance", "Intuition", "Spiritual growth"],
    howToWear: "Wear on the middle finger.",
    bestDay: "Monday",
    category: "gemstone",
  },
  {
    id: "lapis-lazuli",
    name: "Lapis Lazuli",
    img: lapisLazuliImg,
    price: 2499,
    oldPrice: 4999,
    offer: "50% OFF",
    desc: "Enhances wisdom, intuition, and spiritual awareness.",
    description: "Lapis Lazuli improves mental clarity, wisdom, and spiritual insight.",
    benefits: ["Wisdom", "Intuition", "Spiritual awareness"],
    howToWear: "Wear on the index or middle finger.",
    bestDay: "Thursday",
    category: "gemstone",
  },
  {
    id: "onyx",
    name: "Onyx",
    img: onyxImg,
    price: 1999,
    oldPrice: 3999,
    offer: "50% OFF",
    desc: "Protects from negativity and enhances strength.",
    description: "Onyx provides protection, inner strength, and mental stability.",
    benefits: ["Protection", "Strength", "Stability"],
    howToWear: "Wear on the middle or index finger.",
    bestDay: "Saturday",
    category: "gemstone",
  },
  {
    id: "sunstone",
    name: "Sunstone",
    img: sunstoneImg,
    price: 2499,
    oldPrice: 4999,
    offer: "50% OFF",
    desc: "Brings joy, positivity, and vitality.",
    description: "Sunstone improves energy, positivity, and overall vitality.",
    benefits: ["Joy", "Positivity", "Vitality"],
    howToWear: "Wear on the index or ring finger.",
    bestDay: "Sunday",
    category: "gemstone",
  },
  {
    id: "bloodstone",
    name: "Bloodstone",
    img: bloodstoneImg,
    price: 1999,
    oldPrice: 3999,
    offer: "50% OFF",
    desc: "Enhances courage, vitality, and health.",
    description: "Bloodstone improves courage, energy, and physical vitality.",
    benefits: ["Courage", "Vitality", "Health"],
    howToWear: "Wear on the middle finger.",
    bestDay: "Tuesday",
    category: "gemstone",
  },
  {
    id: "malachite",
    name: "Malachite",
    img: malachiteImg,
    price: 2499,
    oldPrice: 4999,
    offer: "50% OFF",
    desc: "Promotes transformation, protection, and healing.",
    description: "Malachite enhances spiritual growth, protection, and healing energy.",
    benefits: ["Transformation", "Protection", "Healing"],
    howToWear: "Wear on the index or middle finger.",
    bestDay: "Thursday",
    category: "gemstone",
  },
  {
  id: "seven-chakra-ring",
  name: "Seven Chakra Copper Magnetic Ring for Men & Women",
  img: sevenChakraRing,
  price: 499,
  oldPrice: 1999,
  offer: "55% OFF",
  desc: "Balances chakras, enhances energy flow, and promotes overall well-being.",
  description:
    "This Seven Chakra Copper Magnetic Ring is designed to align your chakras, improve energy flow, and support physical and emotional wellness. Suitable for both men and women.",
  benefits: [
    "Balances all seven chakras",
    "Enhances energy and vitality",
    "Supports stress relief and mental clarity"
  ],
  howToWear: "Wear on the finger that feels most comfortable, preferably daily for optimal benefits.",
  bestDay: "Monday and Thursday are considered most auspicious for wearing healing accessories.",
  category: "healing-accessories",
},
];




export default products;
